import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  ScenographieNoRecyclableType,
  ScenographieNoRecyclableValues,
  Source,
  SourceValues,
  ValuesScenographyNoRecyclable,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionScenographyNoRecyclableDto } from './dto.type';

export class QuestionScenographyNoRecyclableMapper {
  static dtoToEntity(
    dto: QuestionScenographyNoRecyclableDto,
  ): ImpactCo2Answer<ValuesScenographyNoRecyclable> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'SCENOGRAPHY_NO_RECYCLABLE',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        scenographieNoRecyclableType:
          validateValueInType<ScenographieNoRecyclableType>(
            dto.scenographieNoRecyclableType,
            ScenographieNoRecyclableValues,
          ),
        quantity: Number.parseFloat(dto.quantity.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesScenographyNoRecyclable>,
    projectId: number,
  ): Omit<
    QuestionScenographyNoRecyclableDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      scenographieNoRecyclableType: answer.values.scenographieNoRecyclableType,
      quantity: answer.values.quantity,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
